import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import MovementPatternContMain from "presentation/view/container/MovementPattern/MovementPatternContMain";

CommonEntrypoint(<MovementPatternContMain/>)